/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FormToggleSwitch.vue?vue&type=template&id=64b80f16&"
import script from "./FormToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./FormToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FormToggleSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports